// new 1
import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

window.html2canvas = html2canvas;

const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
  const downloadPdfDocument = () => {
    const input = document.getElementById(rootElementId);

    html2canvas(input, {
      useCORS: true,
      scale: 2, // Higher scale for better quality
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 1.0);

      // A4 dimensions in pixels at 96dpi (roughly)
      const pdfWidth = 297; // in mm
      const pdfHeight = 210; // in mm
      const imgWidth = canvas.width * 0.264583; // Convert px to mm
      const imgHeight = canvas.height * 0.264583; // Convert px to mm

      // Scale to fit within a single page
      const aspectRatio = imgWidth / imgHeight;
      let scaledWidth = pdfWidth;
      let scaledHeight = pdfWidth / aspectRatio;

      if (scaledHeight > pdfHeight) {
        scaledHeight = pdfHeight;
        scaledWidth = pdfHeight * aspectRatio;
      }

      const pdf = new jsPDF("l", "mm", "a4");
      const marginX = (pdfWidth - scaledWidth) / 2;
      const marginY = (pdfHeight - scaledHeight) / 2;

      pdf.addImage(
        imgData,
        "JPEG",
        marginX, // Center the image horizontally
        marginY, // Center the image vertically
        scaledWidth,
        scaledHeight
      );
      pdf.save(`${downloadFileName}.pdf`);
    });
  };

  return (
    <button
      onClick={downloadPdfDocument}
      style={{
        padding: "10px 20px",
        backgroundColor: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        fontSize: "16px",
      }}
    >
      Download PDF
    </button>
  );
};

export default GenericPdfDownloader;



//new 2

// import React from "react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// window.html2canvas = html2canvas;

// const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
//   const downloadPdfDocument = () => {
//     const input = document.getElementById(rootElementId);

//     html2canvas(input, {
//       useCORS: true,
//       scale: 2,
//       logging: false,
//       windowWidth: input.scrollWidth,
//       windowHeight: input.scrollHeight,
//     }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/jpeg", 1.0);
//       const pdf = new jsPDF("p", "mm", "a4");

//       // Dimensions of A4 in pixels at 96 dpi
//       const pdfWidth = 210;
//       const pdfHeight = 297;

//       const imgWidth = canvas.width / 4.25; // Convert canvas width to mm
//       const imgHeight = (canvas.height * pdfWidth) / canvas.width;

//       let yPosition = 0;

//       // Split canvas image into multiple pages if necessary
//       while (yPosition < imgHeight) {
//         const heightLeft = Math.min(imgHeight - yPosition, pdfHeight);

//         pdf.addImage(
//           imgData,
//           "JPEG",
//           0,
//           0,
//           pdfWidth,
//           heightLeft, // Render the visible portion
//           undefined,
//           "FAST"
//         );

//         yPosition += pdfHeight;

//         if (yPosition < imgHeight) {
//           pdf.addPage();
//         }
//       }

//       pdf.save(`${downloadFileName}.pdf`);
//     });
//   };

//   return (
//     <button
//       onClick={downloadPdfDocument}
//       style={{
//         padding: "10px 20px",
//         backgroundColor: "#007bff",
//         color: "white",
//         border: "none",
//         borderRadius: "4px",
//         cursor: "pointer",
//         fontSize: "16px",
//       }}
//     >
//       Download PDF
//     </button>
//   );
// };

// export default GenericPdfDownloader;


// unused

// import React from "react";
// import html2canvas from "html2canvas";
// // import * as jsPDF from "jspdf";
// import jsPDF from "jspdf";
// window.html2canvas = html2canvas;

// const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
//   const downloadPdfDocument = () => {
//     const input = document.getElementById(rootElementId);
//     html2canvas(input, { useCORS: true }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/jpeg", 1.0);

//       canvas.width = document.body.clientWidth;
//       // const pdf = new jsPDF("l", "mm", "a4");
//       const pdf = new jsPDF("p", "mm", "a4");
//       // pdf.addImage(imgData, "JPEG", 10, 10, 268, 200);
//       pdf.addImage(imgData, "JPEG", 10, 10, 189, 267);
//       pdf.save(`${downloadFileName}.pdf`);
//     });
//   };

//   return (
//     <button
//       className="btn btn-default align-self-center d-none d-md-flex"
//       style={{
//         color: "#1782F4",
//         //   border: '3px solid #00f',
//         borderRadius: "5px !important",
//         background: "#fff",
//       }}
//       onClick={downloadPdfDocument}
//     >
//       <strong>Print PDF</strong>
//     </button>
//   );
// };

// export default GenericPdfDownloader;



// old

// import React from "react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// window.html2canvas = html2canvas;

// const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
//   const downloadPdfDocument = () => {
//     const input = document.getElementById(rootElementId);

//     html2canvas(input, {
//       useCORS: true,
//       scale: 2, // Increased scale for better quality
//       logging: false,
//       windowWidth: input.scrollWidth,
//       windowHeight: input.scrollHeight,
//     }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/jpeg", 1.0);

//       // Get dimensions
//       const pdfWidth = 210; // A4 width in mm
//       const pdfHeight = 297; // A4 height in mm

//       // Calculate dimensions while maintaining aspect ratio
//       const imgWidth = canvas.width;
//       const imgHeight = canvas.height;
//       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

//       const imgX = (pdfWidth - imgWidth * ratio) / 2;
//       const imgY = 30; // Add some top margin

//       const pdf = new jsPDF("p", "mm", "a4");
//       pdf.addImage(
//         imgData,
//         "JPEG",
//         imgX,
//         imgY,
//         imgWidth * ratio,
//         imgHeight * ratio
//       );
//       pdf.save(`${downloadFileName}.pdf`);
//     });
//   };

//   return (
//     <button
//       onClick={downloadPdfDocument}
//       style={{
//         padding: "10px 20px",
//         backgroundColor: "#007bff",
//         color: "white",
//         border: "none",
//         borderRadius: "4px",
//         cursor: "pointer",
//         fontSize: "16px",
//       }}
//     >
//       Download PDF
//     </button>
//   );
// };

// export default GenericPdfDownloader;
